/**
 * Created by neo on 21.01.26
 */
import { makeAutoObservable } from 'mobx';
import {
  ExploreWeaviateSearchResultEntry,
  createExploreWeaviateSearchResultEntry,
} from './ExploreWeaviateSearchResultEntry';

export type ExploreWeaviateSearchResult = {
  Content: ExploreWeaviateSearchResultEntry[];
  FitnessProgram: ExploreWeaviateSearchResultEntry[];
  MindfulnessProgram: ExploreWeaviateSearchResultEntry[];
  Recipe: ExploreWeaviateSearchResultEntry[];
  Explore: ExploreWeaviateSearchResultEntry[];
  readonly totalCount: number;
  readonly isEmpty: boolean;
};

export function createExploreWeaviateSearchResult(json?: Partial<ExploreWeaviateSearchResult>): ExploreWeaviateSearchResult {
  return makeAutoObservable({
    Content: (json?.Content ?? []).map((c: any) => createExploreWeaviateSearchResultEntry(c)).filter(Boolean),
    FitnessProgram: (json?.FitnessProgram ?? []).map((p: any) => createExploreWeaviateSearchResultEntry(p)),
    MindfulnessProgram: (json?.MindfulnessProgram ?? []).map((p: any) => createExploreWeaviateSearchResultEntry(p)),
    Recipe: (json?.Recipe ?? []).map((r: any) => createExploreWeaviateSearchResultEntry(r)),
    Explore: (json?.Explore ?? []).map((e: any) => createExploreWeaviateSearchResultEntry(e)).filter(Boolean),

    get totalCount(): number {
      return this.Content.length + this.FitnessProgram.length + this.MindfulnessProgram.length + this.Recipe.length + this.Explore.length;
    },

    get isEmpty(): boolean {
      return this.totalCount === 0;
    },
  });
}
